import { Component, Inject, OnInit, Optional } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-lca-job-details-position',
  templateUrl: './lca-job-details-position.component.html',
  styleUrls: ['./lca-job-details-position.component.scss']
})
export class LcaJobDetailsPositionComponent implements OnInit {
  primaryData = [];
  isForeignCompany = false;

  constructor(@Optional() @Inject('simplifiedH1b') simplifiedH1b: boolean,
  public dynamicDialogConfig: DynamicDialogConfig,) { 
    this.primaryData = this.dynamicDialogConfig.data
  }

  ngOnInit(): void {
  }

}
